import React, { useState, useEffect } from 'react';
import { PropTypes } from 'prop-types';
import { useNavigate, useOutletContext } from 'react-router-dom';
import { useIntl } from 'react-intl';
import AccionaTableButton from './AccionaTableButton.jsx';
import AccionaButton from '../../../../../../../components/AccionaButton';
import RemoveModal from '../../../../../../../components/RemoveModal/index';
import { deleteScannedDocument } from '../../../../../../../services/api/scannedDocuments.js';
import { getFile } from '../../../../../../../services/api/files';
import moment from 'moment';
import generatePDF from './generatePDF.jsx';
import styles from './index.module.scss';

const { dataLabTable, data } = styles;

const AccionaTableLaboratory = ({
  formState,
  viewAction,
  viewLabAction,
  labFileName,
  deliveryFileName,
  paramsUrl,
  workCode,
}) => {
  const intl = useIntl();
  const navigate = useNavigate();
  const { project } = useOutletContext();

  const [showRemoveModal, setShowRemoveModal] = useState(false);
  const [labImg, setLabImg] = useState(false);
  const [deliveryImg, setDeliveryImg] = useState(false);
  const onBack = () => navigate(-1);
  const pdfName = `${workCode}_LABORATORIO_${formState.docket_number}_${moment(
    new Date(),
  ).format('YYYYMMDD')}`;

  useEffect(() => {
    if (labFileName)
      getFile(labFileName, 'laboratory').then((value) => {
        setLabImg(URL.createObjectURL(value.data));
      });
    if (deliveryFileName)
      getFile(deliveryFileName, 'laboratory').then((value) => {
        setDeliveryImg(URL.createObjectURL(value.data));
      });
  }, [labFileName, deliveryFileName]);

  const editAction = () => {
    navigate(
      `/app/project/${project.id_project}/quality/ocr/scannedDocuments/update/laboratory/${paramsUrl.sdId}/${paramsUrl.fileName}`,
    );
  };
  const deleteAction = () => {
    setShowRemoveModal(true);
  };
  const handleOnBulkDeleting = async () => {
    setShowRemoveModal(false);
    try {
      await deleteScannedDocument({ id: paramsUrl.sdId });
      navigate(-1);
    } catch (error) {
      console.error(error);
    }
  };

  const parseCompressiveStrength = () => {
    const result = [];

    Object.keys(formState).forEach((key, i) => {
      if (key.includes('compressive_strength') && formState[key]) {
        result.push({
          value: formState[key],
          days: key.split('_')[2],
          sample: key.split('_')[3],
        });
      }
      if (key.includes('strength_extra') && formState[key]) {
        Object.keys(formState[key]).forEach((k) => {
          if (k.includes('compressive_strength') && formState[key][k]) {
            result.push({
              value: formState[key][k],
              days: k.split('_')[2],
              sample: k.split('_')[3],
            });
          }
        });
      }
    });
    return result;
  };

  const pdfButton = (
    <AccionaButton
      msg={intl.formatMessage({ id: 'generatePDF' })}
      classIcon="icon fas fa-file-invoice"
      onClick={() => {
        generatePDF({
          formState,
          labImg,
          deliveryImg,
          fileName: pdfName,
        });
      }}
    ></AccionaButton>
  );
  const backButton = (
    <AccionaButton
      msg={intl.formatMessage({ id: 'back' })}
      onClick={onBack}
      classIcon="icon fas fa-chevron-left"
    />
  );
  return (
    <div className="wrapper">
      <div
        className="form-row"
        style={{
          marginTop: '30px',
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        {pdfButton}
        {backButton}
      </div>
      <div className="card no-padding no-margin" id="AccionaTable">
        <div className="dataTables_wrapper no-footer">
          <table className="dataTable">
            <tbody className={dataLabTable}>
              <tr style={{ backgroundColor: 'rgb(230, 230, 230)' }}>
                <td
                  style={{
                    color: '#232323',
                  }}
                >
                  {intl.formatMessage({ id: 'supplier_id' })}
                </td>
              </tr>
              <tr>
                <td className={data}>{formState.name}</td>
              </tr>
            </tbody>
          </table>
          <table className={`dataTable ${dataLabTable}`}>
            <tbody>
              <tr style={{ backgroundColor: 'rgb(230, 230, 230)' }}>
                <td
                  style={{
                    color: '#232323',
                    width: '50%',
                  }}
                >
                  {intl.formatMessage({ id: 'phone_number' })}
                </td>
                <td
                  style={{
                    color: '#232323',
                    width: '50%',
                  }}
                >
                  {intl.formatMessage({ id: 'email' })}
                </td>
              </tr>
              <tr>
                <td className={data}>{formState.phone_number}</td>
                <td className={data}>{formState.email}</td>
              </tr>
            </tbody>
          </table>
          <table className={`dataTable ${dataLabTable}`}>
            <tbody>
              <tr style={{ backgroundColor: 'rgb(230, 230, 230)' }}>
                <td
                  style={{
                    color: '#232323',
                    width: '50%',
                  }}
                >
                  {intl.formatMessage({ id: 'docket_number' })}
                </td>
                <td
                  style={{
                    color: '#232323',
                    width: '50%',
                  }}
                >
                  {intl.formatMessage({ id: 'attr.reference_number' })}
                </td>
              </tr>
              <tr>
                <td className={data}>{formState.docket_number}</td>
                <td className={data}>{formState.reference_number}</td>
              </tr>
            </tbody>
          </table>
          <table className={`dataTable ${dataLabTable}`}>
            <tbody>
              <tr style={{ backgroundColor: 'rgb(230, 230, 230)' }}>
                <td
                  style={{
                    color: '#232323',
                  }}
                >
                  {intl.formatMessage({ id: 'testsResults' })}
                </td>
              </tr>
            </tbody>
          </table>
          <table className={`dataTable ${dataLabTable}`}>
            <tbody>
              <tr style={{ backgroundColor: 'rgb(230, 230, 230)' }}>
                <td
                  style={{
                    color: '#232323',
                    width: '50%',
                  }}
                >
                  {intl.formatMessage({ id: 'sampleAge' })}
                </td>
                <td
                  style={{
                    color: '#232323',
                    width: '50%',
                  }}
                >
                  {intl.formatMessage({ id: 'attr.compressive_strength' })}
                </td>
              </tr>
              {parseCompressiveStrength().map((item) => {
                return (
                  <tr key={`sample${item.days}${item.sample}`}>
                    <td className={data}>
                      {intl.formatMessage(
                        {
                          id: 'compressive_strength_sample',
                        },
                        {
                          numberDay: item.days,
                          numberSample: item.sample,
                        },
                      )}
                    </td>
                    <td className={data}>{item.value}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          <table className={`dataTable ${dataLabTable}`}>
            <tbody>
              <AccionaTableButton
                viewAction={viewAction}
                viewLabAction={viewLabAction}
              />
            </tbody>
          </table>
        </div>
      </div>
      <div
        className="form-row"
        style={{
          marginTop: '30px',
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        {pdfButton}

        <AccionaButton
          msg={intl.formatMessage({ id: 'edit' })}
          onClick={editAction}
          classIcon="icon fas fa-pencil-alt"
        />
        <AccionaButton
          msg={intl.formatMessage({ id: 'button.delete' })}
          onClick={deleteAction}
          classIcon="icon fas fa-trash-alt"
        />
        {backButton}
      </div>
      <RemoveModal
        entity="scannedDocuments"
        msg={intl.formatMessage({
          id: 'delete.scannedDocument',
        })}
        onOk={handleOnBulkDeleting}
        onCancel={() => setShowRemoveModal((prev) => !prev)}
        hidden={!showRemoveModal}
      />
    </div>
  );
};

AccionaTableLaboratory.propTypes = {
  formState: PropTypes.object.isRequired, // TODO: Complete with shape()
  viewAction: PropTypes.func.isRequired,
  viewLabAction: PropTypes.func.isRequired,
  labFileName: PropTypes.string,
  deliveryFileName: PropTypes.string.isRequired,
  paramsUrl: PropTypes.object.isRequired,
  workCode: PropTypes.string.isRequired,
};

AccionaTableLaboratory.defaultProps = {
  labFileName: undefined,
};

export default AccionaTableLaboratory;
